<template>
  <div class="main d-flex justify-center align-center flex-column w-100">
    <p class="list__header mx-auto" :class="mdAndDown ? 'mx-auto': 'ml-0 mr-auto'">
      Ingresos mensuales
    </p>
    <div style="width: 100%;" class="d-flex align-center">
      <v-menu
          ref="startDate"
          v-model="startDateMenu"
          :close-on-content-click="false"
          :return-value.sync="startDate"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            class="ml-0 chart-input"
            v-model="startDate"
            label="Mes de inicio"
            prepend-icon="mdi-calendar-month"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="startDate"
            no-title
            scrollable
            locale="es"
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="startDateMenu = false">Cancelar</v-btn>
          <v-btn text color="primary" @click="$refs.startDate.save(startDate); datesUpdated();">OK</v-btn>
        </v-date-picker>
      </v-menu>

      <v-menu
          ref="endDate"
          v-model="endDateMenu"
          :close-on-content-click="false"
          :return-value.sync="endDate"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            class="chart-input mx-6"
            v-model="endDate"
            label="Mes de fin"
            prepend-icon="mdi-calendar-month"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="endDate"
            no-title
            scrollable
            locale="es"
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="endDateMenu = false">Cancelar</v-btn>
          <v-btn text color="primary" @click="$refs.endDate.save(endDate); datesUpdated();">OK</v-btn>
        </v-date-picker>
      </v-menu>

      <v-select
        class="ml-2 chart-input"
        v-model="currentChartType"
        :items="chartTypes" 
        item-text="text"
        item-id="value"
        @change="datesUpdated()"
      >
      </v-select>
      <v-autocomplete
        v-if="showCourseFilter"
        placeholder="Seleccione un curso"
        class="chart-input ml-3"
        v-model="currentCourse"
        :items="courses" 
        item-text="nombre"
        item-value="id"
        @change="onCourseChange"
      >
      </v-autocomplete>
    </div>
    <p v-if="showCourseFilter" class="amount-summary mb-1" @click="$router.push({name: 'Ingresos'})">
      <b>Curso: </b> {{ currentCourseName }}
    </p>
    <p v-if="startDate && endDate" class="amount-summary" @click="$router.push({name: 'Ingresos'})">
      Ingreso total obtenido desde {{ startDate | moment("DD/MM/YYYY") }} hasta {{ endDate | moment("DD/MM/YYYY") }}: <b>S/. {{ montoTotal | roundTwoDecimals }}</b>
    </p>
    <ApexChart
      ref="lineRef"
      width="130%"
      height="200"
      :class="mdAndDown ? 'mx-auto': 'ml-0 mr-auto'"
      type="line"
      :options="options"
      :series="series"
    />
  </div>
</template>

<script>
import axios from 'axios'
import {settingsLinePlot} from '@/utils/graphs/ingresos'

export default {
  props: {
    title: {
      type: String,
      default: 'Ingresos obtenidos'
    },
    showCourseFilter: {
      type: Boolean,
      default: () => { return false }
    },
    globalCategories: { type: Array, default: () => [] },
    globalSections:   { type: Array, default: () => [] },
    globalCategory: { type: String, default: null },
    globalSection:  { type: [Number, String], default: null },
    globalStartDate:{ type: String, default: null },
    globalEndDate:  { type: String, default: null }
  },
  data() {
    return {
      startDate: null,
      startDateMenu: false,
      endDate: null,
      endDateMenu: false,
      series: JSON.parse(JSON.stringify(settingsLinePlot.series)),
      options: JSON.parse(JSON.stringify(settingsLinePlot.options)),
      montoTotal: 0,
      data: [],
      courses: [],
      currentCourseName: '',
      currentCourse: null,
      currentChartType: 'DAILY',
      chartTypes: [
        { value: 'MONTHLY', text: 'Mensual'},
        { value: 'DAILY', text: 'Diario'},
        // { value: 'CUMULATIVE_DAILY', text: 'Diario acumulativo'},
      ]
    }
  },
  filters: {
    roundTwoDecimals: (value) => {
      return Math.round(value * 100) / 100
    }
  },
  computed: {
    mdAndDown() {
      return this.$vuetify.breakpoint.mdAndDown
    },
  },
  watch: {
    globalCategories () { this.datesUpdated() },
    globalSections   () { this.datesUpdated() },
    globalCategory() {
      this.datesUpdated()
    },
    globalSection(newVal){
      if (newVal) { 
        this.currentCourse = newVal   
        this.datesUpdated()
        this.onCourseChange(newVal)
      }
    },
    globalStartDate(newVal) {
      if (newVal) {
        this.startDate = newVal
        this.datesUpdated()
      }
    },
    globalEndDate(newVal) {
      if (newVal) {
        this.endDate = newVal
        this.datesUpdated()
      }
    }
  },
  methods: {
    clearFilters() {
      this.startDate = null
      this.endDate = null
      this.currentChartType = 'DAILY'
      this.currentCourse = null
      this.currentCourseName = ''
      this.getLastTwelveMonths()
      this.datesUpdated()
    },
    onCourseChange(courseId) {
    const course = this.courses.find(c => c.id === courseId)
    this.currentCourseName = course ? course.nombre : ''
    this.datesUpdated()
    },
    getLastTwelveMonths() {
      const temporaryStartDate = new Date()
      temporaryStartDate.setMonth(temporaryStartDate.getUTCMonth())
      temporaryStartDate.setDate(1)
      this.startDate = temporaryStartDate.toISOString().substring(0, 10)

      const temporaryEndDate = new Date()
      temporaryEndDate.setMonth(temporaryEndDate.getUTCMonth() + 1)
      temporaryEndDate.setDate(-1)
      this.endDate = temporaryEndDate.toISOString().substring(0, 10)
    },
    datesUpdated() {
        console.log("✅ Fechas iniciales del Dayli:", this.startDate, this.endDate)
          if (!this.startDate || !this.endDate) {
          console.warn("⚠️ No se puede actualizar utilidades del Dayli: fechas vacías.")
          return
        }
      const startDate = new Date(this.startDate)
      const endDate = new Date(this.endDate)
      this.updateUtilities(startDate.toISOString().substring(0, 10), endDate.toISOString().substring(0, 10), this.currentChartType,this.currentCourse)
    },
    buildQuery(startDate, endDate, chartType, currentCourse) {
      const params = new URLSearchParams()
      if (startDate) params.set('startDate', startDate)
      if (endDate)   params.set('endDate', endDate)

      if (currentCourse) {
        params.append('course', currentCourse)
      } else {
        const secs = Array.isArray(this.globalSections) && this.globalSections.length
          ? this.globalSections
          : (this.globalSection ? [this.globalSection] : [])
        const cats = Array.isArray(this.globalCategories) && this.globalCategories.length
          ? this.globalCategories
          : (this.globalCategory ? [this.globalCategory] : [])

        if (secs.length) secs.forEach(id   => params.append('course', id))
        else if (cats.length) cats.forEach(slug => params.append('categoria', slug))
      }

      if (chartType === 'DAILY') {
        // este componente es “mensual/daily”, si quieres incluir huecos:
        // params.set('includeEmpty', 'true') // solo si lo deseas aquí también
      }
      return params.toString()
    },

    async fetchUtilities(startDate = null, endDate = null, chartType = 'MONTHLY', currentCourse = null) {
      const base = chartType === 'MONTHLY' ? 'api/admin/graficas/pagos_por_mes/?' : 'api/admin/graficas/pagos_por_dia/?'
      const qs = this.buildQuery(startDate, endDate, chartType, currentCourse)
      const { data } = await axios.get(base + qs)
      return data
    },
    formatUtilitiesData(data, currentChartType) {
      this.montoTotal = 0
      if (currentChartType === 'MONTHLY') {
        const series = []
        const categories = []
        data.forEach(item => {
          this.montoTotal += item.monto_total
          series.push(item.monto_total)
          categories.push(item.mes.slice(0, 3))
        })
        return { series, categories }
      } else if (currentChartType === 'DAILY') {
        return {
          series: data.map(item => {
            this.montoTotal += item.monto_total
            return [item.fecha_deposito, item.monto_total]
          }),
          categories: []
        }
      } else {
        let acumulativeTotal = 0
        return {
          series: data.map(item => [item.fecha_deposito, acumulativeTotal+=item.monto_total]),
          categories: []
        }
      }
    },
    async updateUtilities(startDate = null, endDate = null, chartType,currentCourse) {
      const data = await this.fetchUtilities(startDate, endDate, chartType,currentCourse)
      const {series, categories} = this.formatUtilitiesData(data, chartType)
      this.series[0].data = series
      this.options.xaxis.categories = categories
      this.options.xaxis.type = chartType === 'MONTHLY'? 'text': 'datetime'
      this.$refs.lineRef.refresh()
    },
    async fetchSections() {
      const response = await axios.get('api/matriculas/secciones/')
      this.courses = response.data
    }
  },
  async mounted() {
    if (this.showCourseFilter) {
      await this.fetchSections()
    }
    this.getLastTwelveMonths()
    this.datesUpdated()
  }
}
</script>

<style lang="scss" scoped>
.main {
  background-color: #FFF;
  border-radius: 15px;
  padding: 16px;
  width: 100%;
}
.list {
  &__header {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
    color: #455A64;
  }
}
.chart-input {
  max-width: 120px;
}
.amount-summary {
  font-size: 13px;
  color: #455A64;
  align-self: self-start;
}
</style>
